import { useMemo } from "react";

type Gutter = Readonly<{
  height: number;
  width: number;
  x: number;
  y: number;
}>;
export type Gutters = Readonly<{
  bottom: Gutter;
  left: Gutter;
  right: Gutter;
  top: Gutter;
}>;
export const useGutters = (
  gutter: number,
  width: number,
  height: number,
  xOffset: number,
  yOffset: number,
): Gutters =>
  useMemo(() => {
    const toReturn: Gutters = {
      bottom: {
        height: gutter,
        width: width - (xOffset + gutter) * 2,
        x: xOffset + gutter,
        y: height - yOffset - gutter,
      },
      left: {
        height: height - (yOffset + gutter) * 2,
        width: gutter,
        x: xOffset,
        y: yOffset + gutter,
      },
      right: {
        height: height - (yOffset + gutter) * 2,
        width: gutter,
        x: width - xOffset - gutter,
        y: yOffset + gutter,
      },
      top: {
        height: gutter,
        width: width - (xOffset + gutter) * 2,
        x: xOffset + gutter,
        y: yOffset,
      },
    };
    return toReturn;
  }, [gutter, height, width, xOffset, yOffset]);

export const withinGutter = (gutter: Gutter, position: [number, number]): boolean =>
  position[0] >= gutter.x &&
  position[1] >= gutter.y &&
  position[0] <= gutter.x + gutter.width &&
  position[1] <= gutter.y + gutter.height;
